module.exports = __webpack_public_path__ + "img/contacts.2f87e7ee.png";